// extracted by mini-css-extract-plugin
export default {"square":"Box_square__O0XhB","content":"Box_content__TmdId"};